import React, { useEffect } from 'react'
import { useQuery } from 'react-query'
import O_SearchBoxUser from 'components/3_Organisms/Groups/O_SearchBoxUser'
import O_TableUser from 'components/3_Organisms/Groups/O_TableUser'
import O_AddUser from 'components/3_Organisms/Groups/O_AddUser'
import { useFetcher, useInit } from 'hooks/useUserTorokuForm'
import { useIsNotDeleteMessage, useLoading } from 'hooks/usePage'
import { usePageMessage } from 'hooks/usePage'
import { commonMsg } from 'assets/MessageCode'
import { useErrorLogout } from 'hooks/useLogin'
import { useHistory } from 'react-router'
import { useSearchedFormat } from 'hooks/useUserTorokuTable'

const C_UserToroku = (): JSX.Element => {
  const [searchUser, fetcher] = useFetcher()
  const [changePageErrorMessage, deletePageMessage, changeMessage] = usePageMessage()
  const [isNotDeleteMessage, changeIsNotDeleteMessage] = useIsNotDeleteMessage()
  const [backLogin] = useErrorLogout(useHistory())
  const [selectList, searchedFormat] = useSearchedFormat()
  const initSet = useInit()
  useEffect(() => initSet(), [])

  // SWR情報の取得
  const { data: data, refetch: refetch, isFetching: isFetching, isLoading: isLoading, error: error } = useQuery(['postUserInfo', searchUser], fetcher)
  const [loding, changeLoading] = useLoading()
  useEffect(() => {
    if (isLoading || isFetching) {
      changeLoading(true)
    } else {
      if (loding) changeLoading(false)
    }
  }, [isLoading, isFetching])
  useEffect(() => {
    if (isLoading || isFetching) {
      if (!isNotDeleteMessage) deletePageMessage()
    } else {
      if (isNotDeleteMessage) changeIsNotDeleteMessage(false)
    }
  }, [isLoading, isFetching])

  if (isLoading || isFetching || data == undefined) {
    if (selectList.length > 0) searchedFormat()
    return <div>Loading...</div>
  }
  if (error) {
    backLogin()
    changePageErrorMessage(commonMsg.ERROR_MSG)
    return <></>
  }
  const info = data.body
  if (data.message) {
    changeMessage(data)
  }

  return (
    <>
      <O_SearchBoxUser info={info.pullDown} />
      <hr />
      <O_TableUser userList={info.table} isFetching={isFetching} refetch={refetch} />
      {/* アラートダイアログ */}
      <O_AddUser refetch={refetch} />
    </>
  )
}

export default React.memo(C_UserToroku)
